export default {
  'bernau-bei-berlin': {
    name: 'Bernau bei Berlin',
    title: 'Fotobox für Ihre Hochzeit in Bernau bei Berlin mieten',
  },
  'erkner': {
    name: 'Erkner',
    title: 'Fotobox für Ihre Hochzeit in Erkner mieten',
  },
  'ruedersdorf': {
    name: 'Rüdersdorf',
  },
  'strausberg': {
    name: 'Strausberg',
  },
  'neuenhagen-bei-berlin': {
    name: 'Neuenhagen bei Berlin',
  },
  'hoppegarten': {
    name: 'Hoppegarten',
  },
  'schoneiche-bei-berlin': {
    name: 'Schöneiche bei Berlin',
  },
  'panketal': {
    name: 'Panketal',
  },
  'altlandsberg': {
    name: 'Altlandsberg',
  },
  'brieselang': {
    name: 'Brieselang',
  },
  'birkholz': {
    name: 'Birkholz',
  },
  'birkholzaue': {
    name: 'Birkholzaue'
  },
  'lindenberg': {
    name: 'Lindenberg',
  },
  'elisenau': {
    name: 'Elisenau',
  },
  'blumberg': {
    name: 'Blumberg',
  },
  'werneuchen': {
    name: 'Werneuchen',
  },
  'seefeld': {
    name: 'Seefeld',
  },
  'mehrow': {
    name: 'Mehrow',
  },
  'hoenow': {
    name: 'Hönow',
  },
  'petershagen': {
    name: 'Petershagen',
  },
  'lindow': {
    name: 'Lindow',
  },
  'eggersdorf': {
    name: 'Eggersdorf',
  },
  'fredersdorf': {
    name: 'Fredersdorf',
  },
  'vogelsdorf': {
    name: 'Vogelsdorf',
  },
  'woltersdorf': {
    name: 'Woltersdorf',
  },
  'wegendorf': {
    name: 'Wegendorf',
  },
  'malchow': {
    name: 'Malchow',
  },
  'bruchmuehle': {
    name: 'Bruchmühle',
  },
  'birkendwerder': {
    name: 'Birkendwerder',
  },
  'velten': {
    name: 'Velten',
  },
  'oranienburg': {
    name: 'Oranienburg',
  },
  'wandlitz': {
    name: 'Wandlitz',
  },
  'lanke': {
    name: 'Lanke',
  },
  'biesenthal': {
    name: 'Biesenthal',
  },
  'ahrensfelde': {
    name: 'Ahrensfelde',
  },
  'eiche': {
    name: 'Eiche',
  },
  'eberswalde': {
    name: 'Eberswalde',
  },
  'finowfurt': {
    name: 'Finowfurt',
  },
  'bernau': {
    name: 'Bernau',
  },
  'joachimsthal': {
    name: 'Joachimsthal',
  },
  'schorfheide': {
    name: 'Schorfheide',
  },
  'henningsdorf': {
    name: 'Henningsdorf',
  },
  'hohen-neuendorf': {
    name: 'Hohen Neuendorf',
  },
  'muehlenbecker-land' : {
    name: 'Mühlenbecker Land',
  },
  'birkendwerder': {
    name: 'Birkendwerder',
  },
  'gruenheide': {
    name: 'Grünheide',
  },
  'proetzel': {
    name: 'Prötzel',
  },
  'ruednitz': {
    name: 'Rüdnitz',
  },
  'marienwerder' : {
    name: 'Marienwerder',
  }
}